// extracted by css-extract-rspack-plugin
export default {"container":"container-q5aMrl","icon":"icon-qQGqdQ","synastry":"synastry-sntTzF","small":"small-CmEVYt","moon":"moon-lnIRg8","subHeader":"subHeader-YJbbtP"};